import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Authentication
const auth = getAuth(app);

// Function to monitor auth state
const monitorAuthState = (setAuthState) => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setAuthState(user); // Set user state
      } else {
        setAuthState(null); // Clear user state
      }
    });
  };

// Initialize RealtimeDB
const rdb = getDatabase();

// INitializa storage
const storage = getStorage(app);


export { app, db, auth, monitorAuthState, rdb, storage };
